<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)">返回</a>
        <h1>园点编辑</h1>
        <span class="pull-right icon-right orange" v-on:click="updateCurcheInfo()">保存</span>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page">
      <div>
        <span class="block margin-15">园点照片<span class="gray font-12">(最多可以传4张)</span></span>
        <div class="add-pic">
          <ul class="list-group-item clearfix">
            <li v-for="(image, index) in editInfo.curcheImageList">
              <div>
                <img :src="image.baseAcessPath + image.imageAddress" width="80" height="80" /><span class="del" @click="delImage(index)">删除</span>
              </div>
            </li>
            <li v-if="editInfo.curcheImageList && editInfo.curcheImageList.length < 4">
              <div>
                <div class="button-add" @click="capturePhoto();" v-if="isAndroid"></div>
                <div class="button-add" v-else>
                  <form enctype="multipart/form-data" method="post" name="fileinfo">
                    <input type="file" name="pic" id="pic" accept="image/*" multiple="multiple" @change="updateImage()"/>
                  </form>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div>
        <span class="block margin-15">详细资料</span>
          <ul class="list-group-item tinny">
            <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">园点名称：</span><i class="red must">*</i>
              <span class="pull-right gray"><input class="text-right font-14" type="text" placeholder="请填写园点名称" v-model="editInfo.curcheName"></span>
            </div>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">联系电话：</span><i class="red must">*</i>
              <span class="pull-right gray"><input class="text-right font-14" type="number" placeholder="请输入联系电话" v-model="editInfo.field1"></span>
            </div>
          </li>
          <!-- <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">地址：</span><i class="red must pull-left">*</i>
              <span class="block gray" style="margin-left:60px"><input class="text-right font-12" style="width:100%" type="text" placeholder="请填入园点地址" v-model="editInfo.curcherAddress"></span>
            </div>
          </li> -->
          <li>
            <div class="liner"></div>
            <div  class="clearfix  group-txt">
              <span class="pull-left">所在城市：<i class="red must">*</i></span>
              <label class="clearfix forselect text-right" style="float:right;margin-left:15px" for="citySelect">
                <span class="gray" @click="dialogObj.city = true">{{city}}</span>
                <span class="selectbar">
                  <!-- <select id="citySelect" v-model="city" @change="citySelected($event)">
                    <option value='请选择'>请选择</option>
                    <option v-for="item in cityInfo" v-bind:value="item.cityName" v-bind:id="item.cityId">{{item.cityName}}</option>
                  </select> -->
                </span>
              </label>
              <label class="clearfix forselect margin-x-15 text-right" style="float:right" for="proSelect">
                <span class="gray" @click="dialogObj.pro = true">{{pro}}</span>
                <span class="selectbar">
                  <!-- <select id="proSelect" v-model="pro" @change="proSelected($event)">
                    <option value='请选择'>请选择</option>
                    <option v-for="item in proInfo" v-bind:value="item.provinceName" v-bind:id="item.provinceId">{{item.provinceName}}</option>
                  </select> -->
                </span>
              </label>
            </div>
          </li>
           <li class="list-group">
            <div class="liner"></div>
            <label class="clearfix group-txt img-more forselect" for="areaSelect">
              <span class="pull-left">所在区：</span><i class="red must">*</i>
              <span class="pull-right margin-x-15 gray font-12" @click="dialogObj.area = true">{{area}}</span>
              <span class="selectbar">
                <!-- <select id="areaSelect" v-model="area" @change="areaSelected($event)">
                  <option value='请选择'>请选择</option>
                  <option v-for="item in areaInfo" v-bind:value="item.areaName" v-bind:id="item.areaId">{{item.areaName}}</option>
                </select> -->
              </span>
            </label>
          </li>
          <!-- <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">地址：</span><i class="red must pull-left">*</i>
              <span class="block gray" style="margin-left:60px"><input class="text-right font-12" style="width:100%" type="text" placeholder="请输入详细地址" v-model="detailAddress"></span>
            </div>
          </li> -->
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">地址：</span><i class="red must pull-left">*</i>
              <span class="block gray" style="margin-left:60px"><input class="text-right font-12" style="width:100%" type="text" placeholder="请填入园点地址" v-model="editInfo.curcherAddress"></span>
            </div>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">服务学校：</span><i class="red must">*</i>
              <span class="pull-right gray"><input class="text-right font-14" type="text" placeholder="请填入服务学校" v-model="editInfo.serviceSchool"></span>
            </div>
          </li>
          </ul>
      </div>

      <div>
        <span class="block margin-15">服务及资费</span>
        <ul class="list-group-item primary set-host">
          <li class="list-group" v-for="item in editInfo.curcheServiceList" @click="serviceliClick($event)">
            <div class="liner"></div>

            <div class="clearfix padding-15" v-if="cookie_login_data.jobId == 1 || cookie_login_data.jobId == 2">
              <i  v-if="item.csId !== null" class="img-checkbox checked" @click.stop="getDeleteCurcheService(item)"></i>
              <i v-else="item.csId === null" class="img-checkbox" v-bind:class="{'checked': item.curcheId }" @click.stop="setCurche(item)"></i>
              <div class="about">
                <strong>{{ item.serviceName }}</strong>
                <p class="gray font-12">{{ item.serviceRemark }}</p>
              </div>
              <div class="set-price clearfix">
                <input v-if="item.curcheId" type="number" v-model="item.nextServiceFee" placeholder="请输入"/>
                元/月
                <input v-else type="number" placeholder="请输入" readonly="readonly">
              </div>
            </div>

          </li>
        </ul>
      </div>
    </div>
    <div class="bottom-bar hide">
      <a class="button button-primary block"  >确定</a>
    </div>

    <!-- 选择省份 -->
    <div class="maskdiv" v-show="dialogObj.pro" @click="dialogObj.pro = false">
      <div class="slider">
        <strong class="tit">选择省份</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in proInfo">
            <li @click="proSelected(item)">
              <div class="clearfix group-link"><span class="pull-left">{{item.provinceName}}</span>
              <template v-if="item.provinceId == proId">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              </div>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 选择城市 -->
    <div class="maskdiv" v-show="dialogObj.city" @click="dialogObj.city = false">
      <div class="slider">
        <strong class="tit">选择城市</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in cityInfo">
            <li @click="citySelected(item)">
              <div class="clearfix group-link"><span class="pull-left">{{item.cityName}}</span>
              <template v-if="cityId == item.cityId">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              </div>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 选择地区 -->
    <div class="maskdiv" v-show="dialogObj.area" @click="dialogObj.area = false">
      <div class="slider">
        <strong class="tit">选择地区</strong>
        <div class="liner"></div>
        <div class="list-group-item tinny">
          <ul v-for="item in areaInfo">
            <li @click="areaSelected(item)">
              <div class="clearfix group-link"><span class="pull-left">{{item.areaName}}</span>
              <template v-if="areaId == item.areaId">
                <i class="pull-right img-checkbox checked"></i>
              </template>
              <template v-else>
                <i class="pull-right img-checkbox"></i>
              </template>
              </div>
              <div class="liner"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast, Indicator } from 'mint-ui'
import { service, uploadMulUrl } from '../../service'
import { mapMutations } from 'vuex'

export default {
  data () {
    return {
      login_data: JSON.parse(window.localStorage['login_data']),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      get_curche_edit_para: service.setPara('editCurcheInfo'),
      get_delete_curche_service_para: service.setPara('deleteCurcheService'),
      get_update_curche_info_para: service.setPara('updateCurcheInfo'),
      get_Pro_Msg_Para: service.setPara('getPro'),
      get_City_Msg_Para: service.setPara('getNewCity'),
      get_Area_Msg_Para: service.setPara('getArea'),
      updateCurcheInfoParams: {},
      editInfo: {},
      curcheId: 0,
      csId: 0,
      cityShow: '',
      proId: 0,
      pro: '请选择',
      cityId: 0,
      city: '请选择',
      areaId: 0,
      area: '',
      proInfo: {},
      cityInfo: {},
      areaInfo: {},
      isAndroid: true,
      dialogObj: {pro: false, city: false, area: false}
    }
  },
  mounted: function () {
    let b = window.browser()
    this.isAndroid = b.android

    if (this.cookie_login_data.jobId > 2) {
      this.$router.push('/index')
      return
    }
    this.getCurcheEditMsg()
    this.getProMsg()
  },
  methods: {
    ...mapMutations([
      'clearCurche'
    ]),
    getCurcheEditMsg: function () {
      this.curcheId = this.cookie_login_data.curcheId
      this.get_curche_edit_para.curcheId = this.curcheId

      let that = this
      let obj = {context: this, para: this.get_curche_edit_para, successFun: (response) => {
        that.editInfo = response.data
        that.area = that.editInfo.areaName
        that.areaId = that.editInfo.areaId
        that.city = that.editInfo.cityName
        that.cityId = that.editInfo.cityId
        if (that.editInfo.provinceName == '') {
          that.pro = '请选择'
          that.proId = null
        } else {
          that.pro = that.editInfo.provinceName
          that.proId = that.editInfo.provinceId
          this.getCityMsg()
          this.getAreaMsg()
        }
      }}
      service.request(obj)
    },
    getDeleteCurcheService: function (item) {
      this.get_delete_curche_service_para.csId = item.csId

      let obj = {context: this, para: this.get_delete_curche_service_para, successFun: (response) => {
        item.csId = null
        item.curcheId = null
        item.currentServiceFee = null
        item.nextServiceFee = null
      }}
      service.request(obj)
    },
    setCurche: function (item) {
      if (item.curcheId) {
        item.curcheId = null
      } else {
        item.curcheId = this.curcheId
      }
    },
    updateCurcheInfo: function () {
      this.get_update_curche_info_para.curcheId = this.curcheId
      this.get_update_curche_info_para.curcheName = this.editInfo.curcheName
      this.get_update_curche_info_para.curchePhone = this.editInfo.field1
      this.get_update_curche_info_para.curcheAddress = this.editInfo.curcherAddress
      this.get_update_curche_info_para.serviceSchool = this.editInfo.serviceSchool
      this.get_update_curche_info_para.provinceId = this.proId
      this.get_update_curche_info_para.cityId = this.cityId
      this.get_update_curche_info_para.areaId = this.areaId
      if (!this.get_update_curche_info_para.provinceId) {
        Toast('请选择省份')
        return
      }
      if (!this.get_update_curche_info_para.cityId) {
        Toast('请选择城市')
        return
      }
      if (!this.get_update_curche_info_para.areaId) {
        Toast('请选择区域')
        return
      }
      var imageArray = []
      for (var j = 0; j < this.editInfo.curcheImageList.length; j++) {
        imageArray.push(this.editInfo.curcheImageList[j].imageAddress)
      }
      if (imageArray.length > 0) {
        this.get_update_curche_info_para.curcheImages = imageArray
      }
      var curcheServiceList = []
      for (var i = 0; i < this.editInfo.curcheServiceList.length; i++) {
        var curcheServiceListElement = {}
        if (this.editInfo.curcheServiceList[i].curcheId !== null && this.editInfo.curcheServiceList[i].nextServiceFee === null) {
          // statement
          Toast('选择的服务未填写服务资费')
          return
        } else {
          // for (var j = 0; j < curcheServiceList.length; j++) {
          //   if (curcheServiceListElement.curcheName === curcheServiceList[j].curcheName) {
          //    // statement
          //     continue
          //   }
          curcheServiceListElement.curcheId = this.editInfo.curcheServiceList[i].curcheId
          curcheServiceListElement.csId = this.editInfo.curcheServiceList[i].csId
          curcheServiceListElement.serviceId = this.editInfo.curcheServiceList[i].serviceId
          curcheServiceListElement.nextServiceFee = this.editInfo.curcheServiceList[i].nextServiceFee
          curcheServiceList.push(curcheServiceListElement)
          // };
        }
      }
      this.get_update_curche_info_para.curcheServiceList = curcheServiceList

      let obj = {context: this, para: this.get_update_curche_info_para, successFun: (response) => {
        Toast('修改成功')
        this.$store.dispatch('clearCurche')
        this.login_data[this.cookie_login_data.index].curcheName = this.editInfo.curcheName
        window.localStorage['login_data'] = JSON.stringify(this.login_data)
        window.history.go(-1)
      }}
      service.request(obj)
    },
    updateImage: function () {
      var imageLength = document.getElementById('pic').files.length
      if (imageLength === 0) {
        return
      }

      if (imageLength + this.editInfo.curcheImageList.length > 4) {
        Toast('最多只能再上传' + (4 - this.editInfo.curcheImageList.length) + '张图片')
        return
      }

      let that = this
      var data = new window.FormData()
      var nowLength = 0

      for (var i = 0; i < imageLength; i++) {
        lrz(document.getElementById('pic').files[i], {width: 800})
          .then(function (rst) {
            data.append('pic', rst.file, rst.origin.name)
            nowLength++
            if (nowLength == imageLength) {
              // Indicator.open('上传中...')

              let url = uploadMulUrl + that.cookie_login_data.phoneNum + '&needThumb=1'
              let obj = {context: that, para: data, url: url, successFun: (response) => {
                for (var i = 0; i < response.data.length; i++) {
                  var imageInfo = {}
                  imageInfo.baseAcessPath = response.data[i].image.baseAcessPath
                  imageInfo.imageAddress = response.data[i].image.srcFilePath
                  that.editInfo.curcheImageList.push(imageInfo)
                }
              }}
              service.request(obj)
            }
          })
      }
    },
    getProMsg: function () { // 获取省份数据
      this.get_Pro_Msg_Para.randomPara = 123

      let that = this
      let obj = {context: this, para: this.get_Pro_Msg_Para, successFun: (response) => {
        that.proInfo = response.data
      }}
      service.request(obj)
    },
    getCityMsg: function () { // 获取城市
      if (this.pro == '请选择') {
        return
      }
      this.get_City_Msg_Para.randomPara = 123
      this.get_City_Msg_Para.provinceId = this.proId

      let that = this
      let obj = {context: this, para: this.get_City_Msg_Para, successFun: (response) => {
        that.cityInfo = response.data
      }}
      service.request(obj)
    },
    getAreaMsg: function () { // 获取地区
      if (this.city == '请选择') {
        return
      }
      this.get_Area_Msg_Para.cityId = this.cityId

      let that = this
      let obj = {context: this, para: this.get_Area_Msg_Para, successFun: (response) => {
        that.areaInfo = response.data
      }}
      service.request(obj)
    },
    proSelected: function (item) {
      this.proId = item.provinceId
      this.pro = item.provinceName
      this.dialogObj.pro = false
      this.getCityMsg()
      this.city = '请选择'
      this.area = '请选择'
      this.areaInfo = []
      this.areaId = ''
      this.cityInfo = []
      this.cityId = ''
    },
    citySelected: function (item) {
      this.cityId = item.cityId
      this.city = item.cityName
      this.dialogObj.city = false
      this.getAreaMsg()
      this.area = '请选择'
      this.areaInfo = []
      this.areaId = ''
    },
    areaSelected: function (item) {
      this.areaId = item.areaId
      this.area = item.areaName
      this.dialogObj.area = false
    },
    delImage: function (index) {
      this.editInfo.curcheImageList.splice(index, 1)
    },
    serviceliClick: function (event) {
      // $(event.target).parents('.list-group').find('i').click()
      // $(event.target).parents('.list-group').find(':input').focus()
    },
    capturePhoto: function () {
      Indicator.open()
      navigator.camera.getPicture(this.onPhotoDataSuccess, this.onFail, { quality: 50, destinationType: navigator.camera.DestinationType.DATA_URL, sourceType: navigator.camera.PictureSourceType.PHOTOLIBRARY, targetWidth: 1000, targetHeight: 2000 })
    },
    onPhotoDataSuccess: function (imageData) {
      let imgData = 'data:image/jpeg;base64,' + imageData
      let f = {}
      f.file = this.dataURLtoBlob(imgData)
      f.name = '0.png'

      var data = new window.FormData()
      data.append('pic', f.file, f.name)
      let url = uploadMulUrl + this.cookie_login_data.phoneNum + '&needThumb=1'
      let obj = {context: this, para: data, url: url, successFun: (response) => {
        for (var i = 0; i < response.data.length; i++) {
          var imageInfo = {}
          imageInfo.baseAcessPath = response.data[i].image.baseAcessPath
          imageInfo.imageAddress = response.data[i].image.srcFilePath
          this.editInfo.curcheImageList.push(imageInfo)
          Indicator.close()
        }
      }}
      service.request(obj)
    },
    onFail: function (message) {
      Indicator.close()
      // alert('Failed because: ' + message)
    },
    dataURLtoBlob: function (dataurl) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = window.atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new window.Blob([u8arr], {type: mime})
    }
  }
}
</script>



// WEBPACK FOOTER //
// CurcheEdit.vue?9141f156